module.exports = __webpack_public_path__ + "img/blog-17-1.475707ba.webp";